// @flow

import * as React from 'react'

/**
 * The node ICU data are diferent on macOs and on Bitbucket Pipelines.
 * We normalize the macOs one to match the basic HTML non-breaking space char (@nbsp;)
 */
const normalizeNonBreakingSpace = str => str.replace(' ', ' ')

export default ({
  amount,
  withDecimal = false,
}: {
  amount: number,
  withDecimal?: boolean,
}) => {
  return (
    <span>
      {normalizeNonBreakingSpace(
        amount.toLocaleString('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          currencyDisplay: 'symbol',
          useGrouping: true,
          minimumFractionDigits: 0,
          maximumFractionDigits: withDecimal ? 2 : 0,
        }),
      )}
    </span>
  )
}
